export default function Machines_D_3 (number = 1) {
  return {
    name: '电弧熔炉',
    icon: '/static/img/machines/d3.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_3.js